export default () => ({
  trigger: {
    name: 'order_status_element.click_track_and_trace',
    params: {},
  },
  config: {
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
        content: 'track_and_trace',
      },
    },
  },
});
